import { CustomerType, getCustomerTypeEndpoint } from 'common';
import { getSimpleDataFetchSlice } from '@cp-shared-10/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';

const { reducer, fetchData, updateData } = getSimpleDataFetchSlice<CustomerType, DefaultBusinessMarketApiErrorCode>({
    dataName: 'customerType',
    fetchCallback() {
        return CpDataApi.get(getCustomerTypeEndpoint()).then((response) => response.data);
    },
});

export default reducer;
export const fetchCustomerType = fetchData;
export const updateCustomerType = updateData;
